import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ReportIncorrectDetails } from './report-incorrect-details.model';
import { SettingsService } from '../../services/settings.service';

@Injectable()
export class ReportIncorrectDetailsService {
  constructor(private http: HttpClient) {}

  sendReport = (reportIcorrectDetails: ReportIncorrectDetails): Observable<boolean> => {
    const serviceUrl = SettingsService.api.reportIncorrectDetailsUrl;

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http
      .post<string>(serviceUrl, JSON.stringify(reportIcorrectDetails), {
        headers,
      })
      .pipe(
        map(
          (response) => (response ? true : false), // from angular 7 upgrade, need to check still works
        ),
        catchError((error) => throwError(error)),
      );
  };
}
